import React from 'react';
import { useFrontload } from 'react-frontload';
import { useSelector } from 'react-redux';
import { apiV1 } from '../../lib/api';
import { getStateBySlug } from '../../lib/states';
import { prismicOmniaApi, PrismicTagPrefixes } from '../../prismic';
import { getStates } from '../../redux/reference_data';
import { LAKE_HERO_TAG } from '../content_list/content_list';
import Loading from '../loading/loading';
import { StateDetailComponent } from './state_detail';
import styles from './state_detail.less';

interface OwnProps {
  slug: string;
}

export const StateDetailContainer = (props: OwnProps) => {
  const { slug } = props;

  const states = useSelector(getStates);
  const currentState = getStateBySlug(states, slug);

  const { abbr } = currentState;

  const { data, frontloadMeta } = useFrontload(`StateDetailContainer:${slug}`, async () => {
    const [mediaRes, stateRes, qasRes] = await Promise.all([
      apiV1.mediaFetch({
        per_page: 100,
        states: [abbr],
        exclude_tags: [LAKE_HERO_TAG],
      }),
      apiV1.stateFetch(slug),
      prismicOmniaApi.qasFetchByTag(`${PrismicTagPrefixes.STATE}${abbr.toLowerCase()}`, 50),
    ]);

    return {
      media: mediaRes.data.data,
      stateDetail: stateRes.data.data,
      qas: qasRes.results,
    };
  });

  const stateDetail = data?.stateDetail;

  if (frontloadMeta.pending) {
    return <Loading className={styles.loadingScreen} text={`Loading ${abbr.toUpperCase()} Data`} />;
  }

  if (!stateDetail) {
    return null;
  }

  return (
    <StateDetailComponent
      stateDetail={stateDetail}
      media={data?.media || []}
      qas={data?.qas || []}
    />
  );
};
